module.exports = __webpack_public_path__ + "img/5.5.COD.1f559c6e.png";